import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { CertificateRepository }
from '../../repositories/certificate.repository';
import { DataDocumentSystemGenerateModel, DocumentSystemGenerateModel } from '../../models/certificate/document-system-generate.model';

export class InsertDocumentSystemGenerateUseCase implements UseCase< DataDocumentSystemGenerateModel, DocumentSystemGenerateModel> {

    constructor(
        private repository:
        CertificateRepository
    ) {}

    execute(params: DataDocumentSystemGenerateModel): Observable<DocumentSystemGenerateModel> {

        return this.repository.insertDocumentSystemGenerate(params);
    }
}